// @noflow
import React from 'react'

import { Button } from '@/components/elements/atoms/Button'
import Card from '@/components/elements/atoms/Card/Card'
import SkeletonParagraph from '@/components/elements/atoms/SkeletonParagraph/SkeletonParagraph'
import Text from '@/components/elements/atoms/Text/Text'
import STYLES from '@/components/pages/SegmentedPausedPage/SegmentedPausedPage.module.sass'

type Props = {
  deliveryDate: string
  deliveryFrequency: number
  dailyAmount: number
  dailyPrice: string
  onClick: () => void
  disabled: boolean
  lazyFutureBoxesLoading: boolean
}

const PlanSummary = ({
  deliveryDate,
  deliveryFrequency,
  dailyAmount,
  dailyPrice,
  onClick,
  disabled,
  lazyFutureBoxesLoading
}: Props): JSX.Element => {
  const namespace = 'account'
  return (
    <Card border="none" padding={24} variant="brandYellow200">
      <div className={STYLES.summaryContent}>
        <div className={STYLES.topSection}>
          <Text
            namespace={namespace}
            text={`segmented_paused_page.coming_back_segment.plan_summary.title`}
            variant="display20"
            margin={false}
            element="h3"
          />
          <div className={STYLES.summaryRows}>
            <div className={STYLES.summaryRow}>
              <Text
                namespace={namespace}
                text={`segmented_paused_page.coming_back_segment.plan_summary.next_box_due`}
                margin={false}
              />
              {lazyFutureBoxesLoading ? (
                <SkeletonParagraph
                  align={'right'}
                  count={1}
                  shortLine={false}
                  width="8.5rem"
                  margin=".5rem 0"
                />
              ) : (
                <Text
                  namespace={namespace}
                  text={deliveryDate}
                  translate={false}
                  margin={false}
                  bold
                  align="right"
                />
              )}
            </div>
            <div className={STYLES.summaryRow}>
              <Text
                namespace={namespace}
                text={`segmented_paused_page.coming_back_segment.plan_summary.delivery_frequency`}
                margin={false}
              />
              <Text
                namespace={namespace}
                text={`segmented_paused_page.coming_back_segment.plan_summary.delivery_frequency_week`}
                variables={{
                  numOfWeeks: deliveryFrequency,
                  count: deliveryFrequency
                }}
                margin={false}
                bold
              />
            </div>
            <div className={STYLES.summaryRow}>
              <Text
                namespace={namespace}
                text={`segmented_paused_page.coming_back_segment.plan_summary.daily_amount`}
                margin={false}
              />
              <Text
                namespace={namespace}
                text={`segmented_paused_page.coming_back_segment.plan_summary.daily_amount_grams`}
                variables={{ dailyAmount: dailyAmount }}
                margin={false}
                bold
              />
            </div>
            <div className={STYLES.summaryRow}>
              <Text
                namespace={namespace}
                text={`segmented_paused_page.coming_back_segment.plan_summary.daily_price`}
                margin={false}
              />
              <Text
                namespace={namespace}
                text={dailyPrice}
                translate={false}
                margin={false}
                bold
              />
            </div>
          </div>
        </div>
        <Button
          onClick={onClick}
          typography={{
            namespace,
            text: `segmented_paused_page.coming_back_segment.plan_summary.cta`
          }}
          fullWidth
          identifier="segmented_paused_page.restart_your_plan_cta"
          disabled={disabled}
        />
      </div>
    </Card>
  )
}

export default PlanSummary
